var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SelectTipoEstaticos',{attrs:{"label":"","subalcance":_vm.params.subalcance,"item-text":"codigoNombre","item-value":"uuid","placeholder":"Seleccione","dense":""},on:{"loaded":function($event){return _vm.onLoadedItems($event)}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }